import React, { useMemo } from "react";
import Label from "../Label";
import { getDomain, getLogoUrl } from "../../utils/stringUtils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserAlt } from "@fortawesome/free-solid-svg-icons";
import { useHistory } from "react-router-dom";
import styled, { useTheme } from "styled-components";
import { REDESIGN_THEMED_PAGES } from "../../constants/app";

interface Props {
  agentName: string;
  layout: string;
}

const Layout: React.FC<Props> = ({ agentName, children, layout }) => {
  const history = useHistory();
  const isRedesignThemedPage = useMemo(() => {
    return REDESIGN_THEMED_PAGES.some((path) =>
      history.location.pathname.includes(path)
    );
  }, [history.location.pathname]);
  const theme = useTheme();
  return (
    <LayoutContainer className={`layout`}>
      <header className="layout--header">
        <a
          className="layout--logo"
          href={window.location.origin}
          title={agentName}
        >
          <img
            alt={agentName}
            src={getLogoUrl(
              getDomain(),
              theme.redesign.header.logoColorVariant
            )}
          />
        </a>
        <ul className="profile-navigation">
          <li>
            <a
              href={`https://${getDomain()}/profile`}
              className="login-btn"
              rel="noopener noreferrer"
              target="_blank"
            >
              <FontAwesomeIcon icon={faUserAlt} />
              <Label labelName="my_tix" tagName="span" />
            </a>
          </li>
        </ul>
      </header>
      <MainContainer
        className="layout--main"
        isRedesignThemedPage={isRedesignThemedPage}
      >
        {children}
      </MainContainer>
    </LayoutContainer>
  );
};

const LayoutContainer = styled.div`
  background: #f8f8f8;
  display: flex;
  flex-direction: column;
  min-height: 100vh;

  .layout--header {
    align-items: center;
    background-color: ${({ theme }) => theme.redesign.header.backgroundColor};
    box-sizing: border-box;
    flex-shrink: 0;
    height: 3.75rem;
    padding: 0.625rem 0.75rem;
    width: 100%;
    display: flex;
    justify-content: space-between;

    .layout--logo {
      height: 2.5rem;
    }

    .layout--logo img {
      height: 100%;
    }

    .profile-navigation {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      padding: 0;
      margin: 0;
      list-style: none;
      height: 55px;

      .login-btn {
        background-color: ${({ theme }) =>
          theme.redesign.header.signInButton.background};
        color: ${({ theme }) => theme.redesign.header.signInButton.color};
        border-radius: ${({ theme }) =>
          theme.redesign.header.signInButton.borderRadius};
        padding: 9px 19px;
        font-size: 18px;
        white-space: nowrap;
        line-height: 1.2;
        border: none !important;
        text-transform: none;
        display: flex;
        flex: 0;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        text-shadow: none !important;
        text-decoration: none !important;
        font-size: 14px;

        &:hover {
          background-color: ${({ theme }) =>
            theme.redesign.header.signInButton.hoverBackground};
        }

        svg {
          margin-right: 5px;
        }
      }
    }
  }

  .layout--main {
    box-sizing: border-box;
    flex-grow: 1;
    padding: 0.75rem 0.5rem;
    margin: 0 auto;
    width: 100%;

    @media (min-width: 600px) {
    }

    @media (min-width: 960px) {
      width: 900px;
    }

    @media (min-width: 1280px) {
      width: 1000px;
    }
  }
`;

const MainContainer = styled.main<{ isRedesignThemedPage: boolean }>`
  ${({ isRedesignThemedPage, theme }) =>
    isRedesignThemedPage &&
    `
    font-family: ${theme.redesign.regularFont};
    background-color: ${theme.redesign.lightBackground} !important; 
    padding: 0!important; 
    width: 100% !important; 
    margin: 0!important;
    `}
`;

export default Layout;
